'use client';

import { LlmTextBlock } from '../../../types';

export type UserMessageProps = LlmTextBlock<'user'>;

export const UserMessage: React.FC<UserMessageProps> = (props) => {
  const { text } = props;
  return (
    <div className="llm__row">
      <div className="llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6">
        <div className="llm__text">
          <h2 className="llm__text-body" data-text dangerouslySetInnerHTML={{ __html: text }} />
        </div>
      </div>
    </div>
  );
};

